import config from "../config/config";
import { getToken } from "../utils/prefix";

export async function setting_create(data) {
  const res = await fetch(config.api_backend + `/setting/create`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      // Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function setting_all(data) {
  const res = await fetch(config.api_backend + `/setting/all`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      // Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function setting_url(data) {
  const res = await fetch(config.api_backend + `/setting/bot/url`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      // Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function api_settingDeleteCheckTask(data) {
  const res = await fetch(config.api_backend + `/setting/delete/checktask`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      // Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}
